import React from "react";

import { TabType } from "@constants";

type FilterCheckboxProps = {
  isInsideDropdown?: boolean;
  type: TabType;
  id: string;
  name: string;
  checkboxValue: string;
  defaultChecked: boolean;
  label: string;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({
  isInsideDropdown = false,
  type,
  id,
  name,
  checkboxValue,
  defaultChecked,
  label,
  handleOnChange,
}) => {
  // const for input ID and label FOR
  const idForLabel = `${type}-${id}`;

  return (
    <span className="ktc-checkbox" title="">
      <input
        className="form-control"
        type="checkbox"
        id={idForLabel}
        name={name}
        value={checkboxValue}
        defaultChecked={defaultChecked}
        onChange={handleOnChange}
      />
      <label
        htmlFor={idForLabel}
        className={`${isInsideDropdown ? "!mr-0 select-none" : "select-none"}`}
      >
        {label}
      </label>
    </span>
  );
};

export default FilterCheckbox;
